import { useState, useEffect } from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";

const PHONE     = "+9779845210977";
const PHONE_DISPLAY = "+977 9845210977";
const WA_MSG    = encodeURIComponent(
  "Hello! 👋 I'm interested in joining Whitehouse Education Zone. Could you please share details about your CEE / IOE / CMAT coaching programs and the admission process?"
);
const WA_LINK   = `https://wa.me/${PHONE}?text=${WA_MSG}`;
const CALL_LINK = `tel:${PHONE}`;

const FAB = "relative flex items-center justify-center w-[52px] h-[52px] rounded-full shadow-md active:scale-95 transition-[transform,background-color] duration-fast ease-standard";

/** Inverted tooltip — `bg-fg`/`text-bg` reads correctly in both themes. */
function Tip({ children }) {
  return (
    <div className="absolute right-14 bg-fg text-bg text-xs font-semibold px-3 py-1.5 rounded-lg shadow-md whitespace-nowrap pointer-events-none">
      {children}
      <span className="absolute right-[-3px] inset-y-0 my-auto w-2 h-2 rotate-45 bg-fg" />
    </div>
  );
}

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const [tooltip, setTooltip] = useState(null); // "wa" | "call" | null

  // Fade in after 1 s so it doesn't flash on first paint
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-5 z-50 flex flex-col items-end gap-3 transition-[opacity,transform] duration-slow ease-arrival ${
        visible ? "opacity-100" : "opacity-0"
      }`}
      style={{ transform: visible ? "translateY(0)" : "translateY(1.5rem)" }}
    >
      {/* ── WhatsApp ── */}
      <div className="relative flex items-center">
        {tooltip === "wa" && <Tip>Chat on WhatsApp</Tip>}
        <a
          href={WA_LINK}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
          onMouseEnter={() => setTooltip("wa")}
          onMouseLeave={() => setTooltip(null)}
          className={`${FAB} bg-success text-bg`}
        >
          {/* Pulse ring — transform + opacity only */}
          <span className="absolute inset-0 rounded-full bg-success opacity-40 animate-ping" />
          <FaWhatsapp size={26} className="relative z-10" />
        </a>
      </div>

      {/* ── Call ── */}
      <div className="relative flex items-center">
        {tooltip === "call" && <Tip>Call {PHONE_DISPLAY}</Tip>}
        <a
          href={CALL_LINK}
          aria-label={`Call ${PHONE_DISPLAY}`}
          onMouseEnter={() => setTooltip("call")}
          onMouseLeave={() => setTooltip(null)}
          className={`${FAB} bg-primary hover:bg-primary-hover text-on-primary`}
        >
          <FaPhoneAlt size={22} className="relative z-10 animate-[wiggle_2s_ease-in-out_infinite]" />
        </a>
      </div>

      {/* Keyframe for phone wiggle */}
      <style>{`
        @keyframes wiggle {
          0%,90%,100% { transform: rotate(0deg); }
          92%          { transform: rotate(-12deg); }
          96%          { transform: rotate(12deg); }
        }
      `}</style>
    </div>
  );
}
